"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[4876],{

/***/ 70528:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ CardUpdateBanner_CardUpdateBanner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/components/layout/Bone/Bone.tsx + 1 modules
var Bone = __webpack_require__(10430);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
;// CONCATENATED MODULE: ./src/compositions/banners/CardUpdateBanner/components/Content/Content.tsx





const Content = (props)=>{
    const { children, className, title, titleStyle = "h4", text, button } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const visualCompensationClassName = !button && !isMobile ? "pb-24" : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, !isMobile && "max-w-[608rem]", visualCompensationClassName),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                name: "64/credit-card-attention"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-8",
                style: titleStyle,
                message: title,
                html: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: isMobile ? "mt-8" : "mt-24",
                style: "p3",
                message: text,
                html: true
            }),
            children,
            Boolean(button) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)("w-full", isMobile ? "mt-16" : "mt-24"),
                children: button
            })
        ]
    });
};
/* harmony default export */ const Content_Content = (Content);

// EXTERNAL MODULE: ./src/compositions/ProductImage/ProductImage.tsx
var ProductImage = __webpack_require__(63834);
;// CONCATENATED MODULE: ./src/compositions/banners/CardUpdateBanner/components/ImageSection/messages.tsx
/* harmony default export */ const messages = ({
    freeProduct: {
        en: "Free product"
    },
    freeFragrance: {
        en: "Free fragrance"
    },
    freeCase: {
        en: "Get a free&nbsp;case"
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/CardUpdateBanner/components/ImageSection/ImageSection.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ImageSection_module = ({"root":"_2TgxX","atomizer":"EZY5Vv","productImage":"eyA84Y","perfumeImage":"wD8DAf","label":"B7kZFo","caseLabel":"Z0pObG","fragranceLabel":"effvnm"});
;// CONCATENATED MODULE: ./src/compositions/banners/CardUpdateBanner/components/ImageSection/images/vial.png
const vial_namespaceObject = __webpack_require__.p + "images/vial_f55310.png";
;// CONCATENATED MODULE: ./src/compositions/banners/CardUpdateBanner/components/ImageSection/ImageSection.tsx









const ImageSection = (props)=>{
    const { className, freeProduct } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const productImage = freeProduct?.rebrandImage;
    const isFreeCase = freeProduct?.typeGroup === "PerfumeCase";
    const isPerfume = freeProduct?.typeGroup === "Perfume";
    const labelClassName = (0,clsx/* default */.Z)("absolute flex items-center justify-center rounded-full bg-gold-30", ImageSection_module.label, isFreeCase ? ImageSection_module.caseLabel : ImageSection_module.fragranceLabel);
    const labelText = isFreeCase ? messages.freeCase : isPerfume ? messages.freeFragrance : messages.freeProduct;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, ImageSection_module.root, "relative flex items-center", !isPerfume && "mr-auto max-w-464"),
        children: [
            isPerfume && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage/* default */.Z, {
                className: (0,clsx/* default */.Z)(ImageSection_module.atomizer, "my-20 ml-auto"),
                src: vial_namespaceObject,
                bgColor: "light-beige"
            }),
            Boolean(productImage) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage/* default */.Z, {
                        className: isPerfume ? `${ImageSection_module.perfumeImage} absolute inset-0 mr-auto` : `${ImageSection_module.productImage} mx-auto`,
                        src: productImage,
                        bgColor: isPerfume ? null : "light-beige"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: labelClassName,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "font-bold uppercase",
                            message: labelText,
                            style: isMobile ? "t3" : "p5",
                            align: "center",
                            color: "black",
                            html: true
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const ImageSection_ImageSection = (ImageSection);

;// CONCATENATED MODULE: ./src/compositions/banners/CardUpdateBanner/messages.ts
/* harmony default export */ const CardUpdateBanner_messages = ({
    noDiscount: {
        title: {
            en: `
        Ooops!<br />
        looks like there was a
        <span class="text-red">problem with your
        {type, select, AMAZON_PAY {Amazon Pay} APPLE_PAY {Apple Pay} PAYPAL {Paypal} other {card}}...
        </span>
      `
        },
        text: {
            en: "Please update your payment info now to reactivate your account!"
        }
    },
    discount: {
        title: {
            en: '<span class="text-red">Update your payment method,</span> get your next {isCurrentOrNearestBilPeriod, select, true {charge} other {month} } for just {charge}'
        },
        text: {
            en: "Save {discount} on your next {isCurrentOrNearestBilPeriod, select, true {charge} other {month} } when you update your payment info now."
        }
    },
    off50: {
        title: {
            en: '<span class="text-red">Update your payment method,</span> get 50% off for your next {isCurrentOrNearestBilPeriod, select, true {charge} other {month} }'
        },
        text: {
            en: "Update your payment info, and your next {isCurrentOrNearestBilPeriod, select, true {charge} other {month} } is 50% off."
        }
    },
    off60: {
        title: {
            en: '<span class="text-red">Update your payment method,</span> get 60% off for your next {isCurrentOrNearestBilPeriod, select, true {charge} other {month} }'
        },
        text: {
            en: "Update your payment info, and your next {isCurrentOrNearestBilPeriod, select, true {charge} other {month} } is 60% off."
        }
    },
    freeCase: {
        title: {
            en: '<span class="text-red">Update your payment method,</span><br />get a free case'
        },
        text: {
            en: `
        Update your payment info, and we\'ll throw <br class="onlyDesktop" />
        a free atomizer case into your next order.
      `
        }
    },
    freeProduct: {
        title: {
            en: '<span class="text-red">Update your payment method,</span><br />get a free scent'
        },
        text: {
            en: `
        Update your payment info, and we'll throw<br class="onlyDesktop" />
        a <b>free bottle of {productName}</b> into your next order.
      `
        }
    },
    paymentMethodInactive: {
        en: `
      Your
      {type, select, AMAZON_PAY {Amazon Pay} APPLE_PAY {Apple Pay} PAYPAL {Paypal} other {card <b>• #</b>}}
      is inactive.
    `
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/CardUpdateBanner/CardUpdateBanner.tsx










const messagesByOffer = CardUpdateBanner_messages;
const CardUpdateBanner = (props)=>{
    const { className, offer, paymentMethod, couponData, isFetching, button } = props;
    const intl = (0,useIntl/* default */.Z)();
    const { isMobile } = (0,useDevice/* default */.Z)();
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
            className: className,
            ignore: isMobile,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
                pw: 100,
                h: isMobile ? 370 : 385,
                bgColor: "light-beige"
            })
        });
    }
    const { freeProduct, totalAmount, discountAmount, discountPercentage, couponApplyPeriod } = couponData || {};
    const { type, lastDigits } = paymentMethod || {};
    const isCreditCard = type === "CREDIT_CARD";
    const isImageSectionVisible = Boolean(freeProduct?.rebrandImage);
    const discount = offer === "discount" && couponData ? discountAmount ? (0,formatPrice/* default */.Z)(discountAmount, {
        removeZeroCents: true
    }) : `${discountPercentage}%` : "";
    const productName = freeProduct?.name ? `${freeProduct.brandInfo.name} ${freeProduct.name}` : "";
    const charge = totalAmount ? (0,formatPrice/* default */.Z)(totalAmount, {
        removeZeroCents: true
    }) : "";
    const { title, text } = messagesByOffer[offer];
    const isCurrentOrNearestBilPeriod = couponApplyPeriod === "CURRENT_OR_NEAREST_BILLING_PERIOD";
    const titleMessage = intl.formatMessage({
        ...title,
        values: {
            type,
            charge,
            isCurrentOrNearestBilPeriod
        }
    });
    const textMessage = intl.formatMessage({
        ...text,
        values: {
            discount,
            productName,
            isCurrentOrNearestBilPeriod
        }
    });
    const paymentInactiveMessage = type ? intl.formatMessage({
        ...CardUpdateBanner_messages.paymentMethodInactive,
        values: {
            type: isCreditCard ? lastDigits : type
        }
    }) : null;
    const finalText = paymentInactiveMessage ? `${paymentInactiveMessage} ${textMessage}` : textMessage;
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx/* default */.Z)(className, "bg-light-beige px-24 pt-24 pb-32 text-center"),
            "data-testid": "cardUpdateBanner",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Content, {
                title: titleMessage,
                text: finalText,
                button: button,
                children: isImageSectionVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSection_ImageSection, {
                    className: button ? "my-24" : "mt-24",
                    freeProduct: freeProduct
                })
            })
        });
    }
    const containerClassName = (0,clsx/* default */.Z)("bg-light-beige pr-36 text-black", isImageSectionVisible ? "flex items-center" : "py-32 text-center");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: containerClassName,
            "data-testid": "cardUpdateBanner",
            children: [
                isImageSectionVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSection_ImageSection, {
                    className: "flex-1",
                    freeProduct: couponData?.freeProduct
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-1 self-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Content, {
                        className: isImageSectionVisible ? null : "mx-auto",
                        title: titleMessage,
                        text: finalText,
                        titleStyle: isImageSectionVisible ? "h4" : "h3",
                        button: button
                    })
                })
            ]
        })
    });
};
/* harmony default export */ const CardUpdateBanner_CardUpdateBanner = (/*#__PURE__*/react.memo(CardUpdateBanner));


/***/ })

}]);